var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoupUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    opacity: 0.2,
    transform: "matrix(-.707107 -.707107 -.707107 .707107 126.13009 47.291475)",
    x: 8.971,
    y: 9.969,
    width: 42.056,
    height: 42.056,
    rx: 4.206
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#66b744",
    transform: "matrix(-.707107 -.707107 -.707107 .707107 125.430089 47.001525)",
    x: 8.971,
    y: 8.979,
    width: 42.056,
    height: 42.056,
    rx: 4.206
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 19a4.19 4.19 0 0 0-2.973 1.234L56.234 44.027a4.16 4.16 0 0 0-1.189 3.459 4.14 4.14 0 0 1 1.189-2.459l23.793-23.793a4.19 4.19 0 0 1 5.945 0l23.793 23.793a4.14 4.14 0 0 1 1.189 2.459 4.16 4.16 0 0 0-1.189-3.459L85.973 20.234A4.19 4.19 0 0 0 83 19z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 27c-5.13 0-9.25 1.19-12.217 3.5-.064.05-.117.107-.18.158l-1.717 1.717c-1.727 2.153-2.6 4.832-2.4 7.43C67 46.65 73.828 52 83 52c6.228 0 8.478 3.19 8.613 4.83.068.82-.09 1.476-1.22 2.352S86.927 61 83 61c-5.476 0-12.016-3.473-12.016-3.473a4 4 0 0 0-5.869 2.326l6.982 6.982C75.002 67.933 78.866 69 83 69c5.063 0 9.126-1.14 12.094-3.355l2.348-2.348c1.564-2.1 2.348-4.65 2.145-7.123C99.02 49.315 92.172 44 83 44c-6.228 0-8.41-3.15-8.537-4.805-.063-.827.1-1.504 1.236-2.38S79.13 35 83 35c5.476 0 12.016 3.473 12.016 3.473a4 4 0 0 0 5.869-2.326l-6.982-6.982C90.998 28.067 87.134 27 83 27z",
    fill: "#000",
    opacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 26c-5.13 0-9.25 1.19-12.217 3.5-.064.05-.117.107-.18.158l-1.717 1.717c-1.727 2.153-2.6 4.832-2.4 7.43C67 45.65 73.828 51 83 51c6.228 0 8.478 3.19 8.613 4.83.068.82-.09 1.476-1.22 2.352S86.927 60 83 60c-5.476 0-12.016-3.473-12.016-3.473a4 4 0 0 0-5.869 2.326l6.982 6.982C75.002 66.933 78.866 68 83 68c5.063 0 9.126-1.14 12.094-3.355l2.348-2.348c1.564-2.1 2.348-4.65 2.145-7.123C99.02 48.315 92.172 43 83 43c-6.228 0-8.41-3.15-8.537-4.805-.063-.827.1-1.504 1.236-2.38S79.13 34 83 34c5.476 0 12.016 3.473 12.016 3.473a4 4 0 0 0 5.869-2.326l-6.982-6.982C90.998 27.067 87.134 26 83 26z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoupUi);
export default __webpack_public_path__ + "static/media/SoupUI.8a8910e3f60e31aea2636d32d6bdd6dd.svg";
export { ForwardRef as ReactComponent };